<template>
	<div class="pagination_wrap">
		<span class="first_page page_title" @click="firstPage">首页</span>
		<el-pagination :layout="layout" @size-change="handleSizeChange" :total="total"  background :current-page.sync="current" :page-sizes="pageSizes" :page-size="pageSize" @current-change="currentChange" >
		</el-pagination>
		<span class="end_page page_title" @click="endPage">尾页</span>
	</div>
</template>

<script>
	export default {
		name: 'pagination',
		props: {
			total: {
				type: Number,
				default: 100
			},
			pageSize: {
				default: 10
			},
			value: {
				type:Number,
				default: 1
			},
			pageSizes: {
				default: () => []
			},
			layout: {
				type:String,
				default: 'total,prev, pager, next'
			},
		},
		data() {
			return {
				current: 1
			}
		},
		methods: {
			firstPage() {
				this.$emit('input', 1)
				this.$emit('change', 1)
			},
			endPage() {
				let current = Math.ceil(this.total / this.pageSize)
				this.$emit('change', current)
				this.$emit('input', current)
			},
			currentChange(size) {
				this.$emit('change', size)
				this.$emit('input', size)
			},
			// 改变每页条数
			handleSizeChange(val) {//每页多少条
				this.$emit('sizeChange', val)
      		}
		},
		watch: {
			value: {
				immediate: true,
				handler(news) {
					this.current = news
				}
			}
		}
	}
</script>

<style lang="less">
	.pagination_wrap {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 40px 0;

		.page_title {
			color: #606266;
			font-size: 14px;
			cursor: pointer;
		}
	}
</style>
